<template>
    <v-container>
        <v-row dense align="center">
            <v-col cols="12" sm="6">
                <sys-select-category-group
                    :model.sync="form.category_group_id"
                    :error="!!errors.category_group_id"
                    :errors="errors.category_group_id"
                    label="Categoria de turma*"
                    dense
                />
            </v-col>
            <v-col cols="12" sm="3">
                <v-text-field
                    v-model="form.position"
                    :error-messages="errors.position"
                    label="Posição*"
                    type="number"
                    min="0"
                    dense
                />
            </v-col>
            <v-col cols="12" sm="3" class="d-flex">
                <v-btn color="primary" small :loading="saving" :disabled="saving" @click.prevent.stop="save()">
                    {{ form.id ? 'Atualizar' : 'Adicionar' }}
                </v-btn>
                <v-btn v-if="form.id" small text class="ml-1" :disabled="saving" @click.prevent.stop="resetForm()">Cancelar</v-btn>
            </v-col>
        </v-row>

        <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            class="elevation-1 mt-2"
            :hide-default-footer="true"
            :items-per-page="-1"
            dense
            no-data-text="Nenhuma posição cadastrada para este tipo de carga horária."
        >
            <template v-slot:item.category="{ item }">
                {{ item.category_group ? item.category_group.name : item.category_group_id }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="primary" @click.prevent.stop="edit(item)">mdi-pencil</v-icon>
                <v-icon small color="error" @click.prevent.stop="confirmDelete(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>

        <v-dialog v-model="showDelete" max-width="420">
            <v-card>
                <v-card-title class="subtitle-1">Excluir posição</v-card-title>
                <v-card-text>
                    Excluir a posição da categoria
                    <strong>{{ toDelete && toDelete.category_group ? toDelete.category_group.name : '' }}</strong>?
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text :disabled="deleting" @click="showDelete = false">Cancelar</v-btn>
                    <v-btn color="error" :loading="deleting" :disabled="deleting" @click="remove()">Excluir</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <emc-alert-snackbar :show="!!message.length" :message="message" :color="error ? 'error' : 'success'" />
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'SysRegisterWorkLoadTypePositions',
    props: {
        workLoadTypeId: {
            required: true
        }
    },
    data: () => ({
        items: [],
        loading: false,
        saving: false,
        deleting: false,
        showDelete: false,
        toDelete: null,
        errors: {},
        error: false,
        message: '',
        form: { id: null, category_group_id: null, position: 0 },
        headers: [
            { text: 'Categoria de turma', value: 'category', sortable: false },
            { text: 'Posição', value: 'position', sortable: false, width: 120 },
            { text: 'Ações', value: 'actions', sortable: false, align: 'end', width: 100 }
        ]
    }),
    watch: {
        workLoadTypeId: {
            immediate: true,
            handler() {
                this.resetForm()
                this.load()
            }
        }
    },
    methods: {
        ...mapActions('workLoadType', [
            'ActionGetWorkLoadTypePositions',
            'ActionCreateWorkLoadTypePosition',
            'ActionUpdateWorkLoadTypePosition',
            'ActionDeleteWorkLoadTypePosition'
        ]),

        notify(text, isError = false) {
            this.message = ''
            this.$nextTick(() => {
                this.error = isError
                this.message = text
            })
        },

        resetForm() {
            this.form = { id: null, category_group_id: null, position: 0 }
            this.errors = {}
        },

        load() {
            if (!this.workLoadTypeId) {
                this.items = []
                return
            }
            this.loading = true
            this.ActionGetWorkLoadTypePositions({ id: this.workLoadTypeId })
                .then(res => { this.items = res.data || [] })
                .catch(err => this.notify((err && err.message) || 'Falha ao carregar as posições.', true))
                .finally(() => { this.loading = false })
        },

        edit(item) {
            this.errors = {}
            this.form = { id: item.id, category_group_id: item.category_group_id, position: item.position }
        },

        save() {
            this.errors = {}
            this.saving = true

            const payload = {
                id: this.workLoadTypeId,
                positionId: this.form.id,
                category_group_id: this.form.category_group_id,
                position: this.form.position === '' ? null : this.form.position
            }

            const request = this.form.id
                ? this.ActionUpdateWorkLoadTypePosition(payload)
                : this.ActionCreateWorkLoadTypePosition(payload)

            request
                .then(res => {
                    this.notify(res.message || 'Posição salva com sucesso.')
                    this.resetForm()
                    this.load()
                })
                .catch(err => {
                    this.errors = (err && err.errors) || {}
                    this.notify((err && err.message) || 'Falha ao salvar a posição.', true)
                })
                .finally(() => { this.saving = false })
        },

        confirmDelete(item) {
            this.toDelete = item
            this.showDelete = true
        },

        remove() {
            if (!this.toDelete) { return }
            this.deleting = true
            this.ActionDeleteWorkLoadTypePosition({ id: this.workLoadTypeId, positionId: this.toDelete.id })
                .then(res => {
                    this.notify(res.message || 'Posição excluída com sucesso.')
                    if (this.form.id === this.toDelete.id) { this.resetForm() }
                    this.showDelete = false
                    this.load()
                })
                .catch(err => this.notify((err && err.message) || 'Falha ao excluir a posição.', true))
                .finally(() => { this.deleting = false })
        }
    }
}
</script>
